import fetchServer from "../../fetchServer";

/**
 * GET /payment/v1/fee — find the default fee document (cardFee, bankTransferFee).
 */
export default async function getDefaultFeeDocument() {
  let result = {
    return: 0,
    msg: "Something went wrong fetching the default fee document",
    data: null,
  };

  try {
    const res = await fetchServer({
      method: "GET",
      url: "/payment/v1/fee?limit=50&offset=0",
    });

    if (res?.data && !res?.data?.error) {
      const list = Array.isArray(res.data?.data)
        ? res.data.data
        : Array.isArray(res.data)
          ? res.data
          : [];
      const def =
        list.find((row) => row?.isDefault === true) || list[0] || null;
      result = {
        return: 1,
        msg: "Successful",
        data: def,
      };
    } else if (res?.data?.error) {
      result.msg = res.data.error;
    }
  } catch (err) {
    console.log("Network Error!", err);
  }

  return result;
}
